import axios from "@/lib/axios";

const getWelcome = () => {
  return axios.get("/facility/welcome");
}

export default getWelcome;
